import React from 'react';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';
import About2 from './../Elements/About2';
import WhatWeDo6 from './../Elements/WhatWeDo6';
import DocumentsSection from './../Elements/DocumentsSection';
import Testimonials2 from './../Elements/Testimonials2';
import Projects1 from './../Elements/Projects1';
import SiteContentContext from '../../content/SiteContentContext';
import { getTranslations, getByPath, resolveMediaSrc } from '../../content/siteContentUtils';

var defaultBannerImg = require('./../../images/banner/5.jpg');

class About1 extends React.Component {
    static contextType = SiteContentContext;

    componentDidMount() {
        function loadScript(src) {
            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/custom.js');
    };

    render() {
        const content = this.context?.content || {};
        const t = getTranslations(content);
        const aboutBanner = t?.pages?.about?.banner || {};
        const bannerImg = resolveMediaSrc(getByPath(content, 'media.pages.aboutBanner', ''), defaultBannerImg);

        return (
            <>
                <Header />
                <div className="page-content">
                    <Banner
                        className="about-banner single-line-banner"
                        title={aboutBanner.title || 'Hakkımızda'}
                        pagename={aboutBanner.pageName || 'Hakkımızda'}
                        description={aboutBanner.description || ''}
                        bgimage={bannerImg}
                    />
                    <About2 />
                    <WhatWeDo6 />
                    <DocumentsSection />
                    <Projects1 />
                    <Testimonials2 separatoralignment="separator-center" />
                </div>

                <Footer />
            </>
        );
    };
};

export default About1;
